import React, { useState, useMemo, useEffect } from 'react'
import axios from "axios";

// ─── Data ─────────────────────────────────────────────────────────────────────



const STATUSES = ['Dostępny', 'Rezerwacja', 'Sprzedany', 'Zapytaj']

const STATUS_META = {
  Dostępny:  { color: '#22c55e', bg: '#f0fdf4', label: 'Dostępny' },
  Rezerwacja:{ color: '#eab308', bg: '#fefce8', label: 'Rezerwacja' },
  Sprzedany: { color: '#94a3b8', bg: '#f1f5f9', label: 'Sprzedany' },
  Zapytaj:   { color: '#f97316', bg: '#fff7ed', label: 'Zapytaj' },
}

// ─── Main Component ───────────────────────────────────────────────────────────

export default function Admin() {
  const [apartments, setApartments] = useState([])


const loadApartments = async () => {
  try {
    const response = await axios.get('/api/apartments');

    setApartments(response.data);

  } catch (error) {
    console.error(error);
  }
};

// Load on mount
useEffect(() => {
  loadApartments();
}, []);


  const [pending, setPending]       = useState({})   // id → new status (unsaved)
  const [saved, setSaved]           = useState({})   // id → timestamp of last save
  const [filterBuilding, setFilterBuilding] = useState('all')
  const [filterStatus,   setFilterStatus]   = useState('all')
  const [filterFloor,    setFilterFloor]     = useState('all')
  const [search,         setSearch]          = useState('')
  const [toast,          setToast]           = useState(null)

  // Pending count
  const pendingCount = Object.keys(pending).length

  // Derived display list
  const displayed = useMemo(() => {
    if(apartments.length>0){

      return apartments.filter(a => {
      const effectiveStatus = pending[a.id] ?? a.status
      if (filterBuilding !== 'all' && a.building !== filterBuilding) return false
      if (filterStatus   !== 'all' && effectiveStatus !== filterStatus) return false
      if (filterFloor    !== 'all' && String(a.floor) !== filterFloor) return false
      if (search && !a.name.toLowerCase().includes(search.toLowerCase())) return false
      return true
    })

    }
    
  }, [apartments, pending, filterBuilding, filterStatus, filterFloor, search])

  // Summary counts (using pending overrides)
  const counts = useMemo(() => {
    if(apartments.length>0){
      const c = { Dostępny: 0, Rezerwacja: 0, Sprzedany: 0, Zapytaj: 0 }
      apartments.forEach(a => { c[pending[a.id] ?? a.status]++ })
      return c
    }
  }, [apartments, pending])

  const handleChange = (id, newStatus) => {
    const original = apartments.find(a => a.id === id).status
    if (newStatus === original) {
      // Revert to original — remove from pending
      setPending(p => { const n = { ...p }; delete n[id]; return n })
    } else {
      setPending(p => ({ ...p, [id]: newStatus }))
    }
  }

  const showToast = (msg, type = 'success') => {
    setToast({ msg, type })
    setTimeout(() => setToast(null), 2500)
  }


  const Logout = async() => {

    await axios.get('/api/logout')

    window.location.reload()
    
  }
  

  const handleSaveAll = async() => {
    if (!pendingCount) return

    let local = [...apartments]
    local = local.map(a => pending[a.id] ? { ...a, status: pending[a.id] } : a)
    setApartments(local)


    await axios.put('/api/save', pending)

    
    const now = Date.now()
    const newSaved = {}
    Object.keys(pending).forEach(id => { newSaved[id] = now })
    setSaved(s => ({ ...s, ...newSaved }))
    setPending({})
    showToast(`Zapisano zmiany dla ${pendingCount} lokali`)

  }


  const Wyloguj = () => {
    // setPending({})
  }


  const handleRevertAll = () => {
    setPending({})
  }

  const handleSaveOne = (id) => {
    if (!pending[id]) return
    setApartments(prev =>
      prev.map(a => a.id === id ? { ...a, status: pending[id] } : a)
    )
    setSaved(s => ({ ...s, [id]: Date.now() }))
    setPending(p => { const n = { ...p }; delete n[id]; return n })
    showToast(`Zapisano ${apartments.find(a=>a.id===id).name}`)
  }

  // Group for display
  const groups = useMemo(() => {
    const map = {}
    displayed?.forEach(a => {
      const key = `Budynek ${a.building} — Piętro ${a.floor}`
      if (!map[key]) map[key] = []
      map[key].push(a)
    })
    return Object.entries(map).sort(([a], [b]) => a.localeCompare(b))
  }, [apartments, displayed])

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Mono:wght@300;400;500&family=Syne:wght@400;500;600;700&display=swap');

        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        body {
          background: #fff;
          color: #0f0f0f;
          font-family: 'Syne', sans-serif;
          min-height: 100vh;
        }

        .cp-root {
          min-height: 100vh;
          background: #fff;
          display: flex;
          flex-direction: column;
        }

        /* Header */
        .cp-header {
          position: sticky;
          top: 0;
          z-index: 100;
          background: #fff;
          border-bottom: 1px solid #ddd;
          padding: 0 32px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 60px;
        }
        .cp-header-left {
          display: flex;
          align-items: baseline;
          gap: 14px;
        }
        .cp-logo {
          font-family: 'Syne', sans-serif;
          font-weight: 700;
          font-size: 15px;
          letter-spacing: 4px;
          color: #c3a478;
          text-transform: uppercase;
        }
        .cp-subtitle {
          font-family: 'DM Mono', monospace;
          font-size: 11px;
          color: #444;
          letter-spacing: 1px;
          text-transform: uppercase;
        }
        .cp-header-right {
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .cp-pending-badge {
          font-family: 'DM Mono', monospace;
          font-size: 11px;
          color: #c3a478;
          background: rgba(195,164,120,0.1);
          border: 1px solid rgba(195,164,120,0.25);
          border-radius: 4px;
          padding: 4px 10px;
          letter-spacing: 0.5px;
        }
        .cp-btn {
          font-family: 'Syne', sans-serif;
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 1px;
          text-transform: uppercase;
          border: none;
          border-radius: 4px;
          padding: 8px 18px;
          cursor: pointer;
          transition: opacity 0.15s;
        }
        .cp-btn:hover { opacity: 0.8; }
        .cp-btn:disabled { opacity: 0.25; cursor: not-allowed; }
        .cp-btn-ghost {
          background: transparent;
          border: 1px solid #2a2a2a;
          color: #666;
        }
        .cp-btn-primary {
          background: #c3a478;
          color: #fff;
        }

        /* Stats bar */
        .cp-stats {
          display: flex;
          gap: 0;
          border-bottom: 1px solid #ddd;
          background: #eee;
        }
        .cp-stat {
          flex: 1;
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 14px 32px;
          border-right: 1px solid #ddd;
          cursor: pointer;
          transition: background 0.15s;
        }
        .cp-stat:last-child { border-right: none; }
        .cp-stat:hover { background: #ddd; }
        .cp-stat.active { background: #ddd; }
        .cp-stat-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          flex-shrink: 0;
        }
        .cp-stat-label {
          font-family: 'DM Mono', monospace;
          font-size: 11px;
          color: #555;
          text-transform: uppercase;
          letter-spacing: 1px;
          flex: 1;
        }
        .cp-stat-count {
          font-family: 'DM Mono', monospace;
          font-size: 20px;
          font-weight: 500;
          color: #0f0f0f;
        }

        /* Toolbar */
        .cp-toolbar {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 16px 32px;
          border-bottom: 1px solid #ddd;
          background: #fff;
          flex-wrap: wrap;
        }
        .cp-search {
          font-family: 'DM Mono', monospace;
          font-size: 12px;
          background: #ddd;
          border: 1px solid #222;
          border-radius: 4px;
          color: #0f0f0f;
          padding: 7px 12px;
          width: 180px;
          outline: none;
          transition: border-color 0.15s;
        }
        .cp-search::placeholder { color: #444; }
        .cp-search:focus { border-color: #c3a478; }
        .cp-select {
          font-family: 'DM Mono', monospace;
          font-size: 11px;
          background: #eee;
          border: 1px solid #222;
          border-radius: 4px;
          color: #000;
          padding: 7px 10px;
          outline: none;
          cursor: pointer;
          transition: border-color 0.15s;
          letter-spacing: 0.5px;
        }
        .cp-select:focus { border-color: #c3a478; color: #0f0f0f; }
        .cp-toolbar-right {
          margin-left: auto;
          font-family: 'DM Mono', monospace;
          font-size: 11px;
          color: #444;
          letter-spacing: 0.5px;
        }

        /* Content */
        .cp-content {
          flex: 1;
          padding: 24px 32px 80px;
          overflow-y: auto;
        }

        /* Group */
        .cp-group {
          margin-bottom: 32px;
        }
        .cp-group-header {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 8px;
        }
        .cp-group-title {
          font-family: 'DM Mono', monospace;
          font-size: 10px;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: #444;
        }
        .cp-group-line {
          flex: 1;
          height: 1px;
          background: #1a1a1a;
        }
        .cp-group-count {
          font-family: 'DM Mono', monospace;
          font-size: 10px;
          color: #333;
        }

        /* Table */
        .cp-table {
          width: 100%;
          border-collapse: collapse;
        }
        .cp-table-head th {
          font-family: 'DM Mono', monospace;
          font-size: 10px;
          letter-spacing: 1.5px;
          text-transform: uppercase;
          color: #333;
          text-align: left;
          padding: 8px 12px;
          border-bottom: 1px solid #1a1a1a;
          font-weight: 400;
        }
        .cp-table-head th:first-child { padding-left: 0; }
        .cp-row {
          border-bottom: 1px solid #ddd;
          transition: background 0.1s;
        }
        .cp-row:hover { background: #ddd; }
        .cp-row.is-dirty { background: rgba(195,164,120,0.04); }
        .cp-row td {
          padding: 11px 12px;
          vertical-align: middle;
        }
        .cp-row td:first-child { padding-left: 0; }

        .cp-name {
          font-family: 'DM Mono', monospace;
          font-size: 13px;
          font-weight: 500;
          color: #0f0f0f;
          letter-spacing: 0.5px;
        }
        .cp-meta {
          font-family: 'DM Mono', monospace;
          font-size: 11px;
          color: #444;
        }

        /* Status pill (read-only display) */
        .cp-status-pill {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          font-family: 'DM Mono', monospace;
          font-size: 11px;
          letter-spacing: 0.5px;
          border-radius: 3px;
          padding: 3px 8px;
        }
        .cp-status-dot {
          width: 5px;
          height: 5px;
          border-radius: 50%;
        }

        /* Status select */
        .cp-status-select {
          font-family: 'DM Mono', monospace;
          font-size: 12px;
          border-radius: 4px;
          padding: 5px 8px;
          outline: none;
          cursor: pointer;
          border: 1px solid transparent;
          transition: border-color 0.15s, background 0.15s;
          min-width: 130px;
          background: #eee;
          color: #000;
          border: 1px solid #222;

        }
        .cp-status-select:focus { border-color: #c3a478; color: #0f0f0f; }
        .cp-status-select.is-dirty {
          border-color: rgba(195,164,120,0.4);
          color: #c3a478;
        }

        /* Row action */
        .cp-row-action {
          display: flex;
          align-items: center;
          gap: 8px;
          justify-content: flex-end;
        }
        .cp-save-one {
          font-family: 'DM Mono', monospace;
          font-size: 10px;
          letter-spacing: 1px;
          text-transform: uppercase;
          background: rgba(195,164,120,0.1);
          border: 1px solid rgba(195,164,120,0.3);
          color: #c3a478;
          border-radius: 3px;
          padding: 4px 10px;
          cursor: pointer;
          transition: background 0.15s;
          white-space: nowrap;
        }
        .cp-save-one:hover { background: rgba(195,164,120,0.2); }
        .cp-dirty-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #c3a478;
          flex-shrink: 0;
        }
        .cp-saved-tick {
          font-family: 'DM Mono', monospace;
          font-size: 10px;
          color: #22c55e;
          letter-spacing: 0.5px;
        }

        /* Empty */
        .cp-empty {
          text-align: center;
          padding: 80px 0;
          font-family: 'DM Mono', monospace;
          font-size: 12px;
          color: #333;
          letter-spacing: 1px;
        }

        /* Toast */
        .cp-toast {
          position: fixed;
          bottom: 32px;
          left: 50%;
          transform: translateX(-50%);
          background: #1a1a1a;
          border: 1px solid #2a2a2a;
          border-radius: 6px;
          padding: 12px 24px;
          font-family: 'DM Mono', monospace;
          font-size: 12px;
          color: #c3a478;
          letter-spacing: 0.5px;
          z-index: 999;
          pointer-events: none;
          animation: toastIn 0.2s ease;
        }
        @keyframes toastIn {
          from { opacity:0; transform: translateX(-50%) translateY(8px); }
          to   { opacity:1; transform: translateX(-50%) translateY(0); }
        }
      `}</style>

      <div className="cp-root">

        {/* Header */}
        <header className="cp-header">
          <div className="cp-header-left">
            <span className="cp-logo">The Sea</span>
            <span className="cp-subtitle">Panel administracyjny</span>

            <button className="cp-btn cp-btn-primary" onClick={Logout}>
              Wyloguj
            </button>

          </div>
          <div className="cp-header-right">
            {pendingCount > 0 && (
              <span className="cp-pending-badge">{pendingCount} niezapisanych zmian</span>
            )}
            <button className="cp-btn cp-btn-ghost" onClick={handleRevertAll} disabled={!pendingCount}>
              Cofnij
            </button>
            <button className="cp-btn cp-btn-primary" onClick={handleSaveAll} disabled={!pendingCount}>
              Zapisz wszystkie
            </button>
          </div>
        </header>

        {/* Stats */}
        <div className="cp-stats">
          {STATUSES.map(s => (
            <div
              key={s}
              className={`cp-stat${filterStatus === s ? ' active' : ''}`}
              onClick={() => setFilterStatus(prev => prev === s ? 'all' : s)}
              title="Kliknij aby filtrować"
            >
              <span className="cp-stat-dot" style={{ background: STATUS_META[s].color }} />
              <span className="cp-stat-label">{s}</span>
              {/* <span className="cp-stat-count">{counts[s]}</span> */}
            </div>
          ))}
        </div>

        {/* Toolbar */}
        <div className="cp-toolbar">
          <input
            className="cp-search"
            placeholder="Szukaj lokalu…"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
          <select className="cp-select" value={filterBuilding} onChange={e => setFilterBuilding(e.target.value)}>
            <option value="all">Wszystkie budynki</option>
            <option value="A">Budynek A</option>
            <option value="B">Budynek B</option>
          </select>
          <select className="cp-select" value={filterFloor} onChange={e => setFilterFloor(e.target.value)}>
            <option value="all">Wszystkie piętra</option>
            <option value="0">Piętro 0</option>
            <option value="1">Piętro 1</option>
            <option value="2">Piętro 2</option>
            <option value="3">Piętro 3</option>
          </select>
          {/* <span className="cp-toolbar-right">{displayed.length} / {apartments.length} lokali</span> */}
        </div>

        {/* Content */}
        <div className="cp-content">
          {groups.length === 0 ? (
            <div className="cp-empty">Brak wyników</div>
          ) : (
            groups.map(([groupKey, apts]) => (
              <div key={groupKey} className="cp-group">
                <div className="cp-group-header">
                  <span className="cp-group-title">{groupKey}</span>
                  <div className="cp-group-line" />
                  <span className="cp-group-count">{apts.length}</span>
                </div>
                <table className="cp-table">
                  <thead className="cp-table-head">
                    <tr>
                      <th>Lokal</th>
                      <th>Pow.</th>
                      <th>Pokoje</th>
                      <th>Aktualny status</th>
                      <th>Nowy status</th>
                      <th style={{ textAlign:'right' }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {apts.map(apt => {
                      const isDirty    = pending[apt.id] !== undefined
                      const wasSaved   = !isDirty && saved[apt.id]
                      const curStatus  = apt.status  // committed status
                      const dispStatus = pending[apt.id] ?? curStatus
                      const meta       = STATUS_META[curStatus]

                      return (
                        <tr key={apt.id} className={`cp-row${isDirty ? ' is-dirty' : ''}`}>
                          <td>
                            <span className="cp-name">{apt.name}</span>
                          </td>
                          <td>
                            <span className="cp-meta">{apt.size} m²</span>
                          </td>
                          <td>
                            <span className="cp-meta">{apt.rooms}</span>
                          </td>
                          <td>
                            <span className="cp-status-pill"
                              style={{ background: meta.bg + '22', color: meta.color }}>
                              <span className="cp-status-dot" style={{ background: meta.color }} />
                              {curStatus}
                            </span>
                          </td>
                          <td>
                            <select
                              className={`cp-status-select${isDirty ? ' is-dirty' : ''}`}
                              value={dispStatus}
                              onChange={e => handleChange(apt.id, e.target.value)}
                            >
                              {STATUSES.map(s => (
                                <option key={s} value={s}>{s}</option>
                              ))}
                            </select>
                          </td>
                          <td>
                            <div className="cp-row-action">
                              {isDirty && (
                                <>
                                  <span className="cp-dirty-dot" />
                                  <button className="cp-save-one" onClick={() => handleSaveOne(apt.id)}>
                                    Zapisz
                                  </button>
                                </>
                              )}
                              {wasSaved && (
                                <span className="cp-saved-tick">✓ zapisano</span>
                              )}
                            </div>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            ))
          )}
        </div>

        {/* Toast */}
        {toast && <div className="cp-toast">{toast.msg}</div>}
      </div>
    </>
  )
}